import "./Assignments.css";
import "react-toastify/dist/ReactToastify.css";

import { SearchOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  InputAdornment,
  LinearProgress,
  OutlinedInput,
  Paper,
  Tooltip,
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

import {
  getAssignments,
  MarkAssingmentDelete,
} from "../../adapter/assignmentAdapter";
import Loader from "../../components/Loader";

function Assignments() {
  const ITEMS_PER_PAGE = 8;
  const navigate = useNavigate();
  const [open, setopen] = useState(false);
  const [assignments, setAssignments] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [assignmentId, setAssignmentId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(5);
  const [showFilter, setShowfilter] = useState(false);
  const [searchtext, setsearchText] = useState("");
  const [allAssigments, setAllAssigments] = useState([]);
  function getAllAssignment() {
    setLoading(true);
    getAssignments()
      .then((response) => {
        if (response === undefined || response === null) {
          setLoading(false);
          toast.error("Something went wrong !");
          setAssignments();
          return;
        }
        setLoading(false);
        setAssignments(response);
        setAllAssigments(response);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Something went wrong !", err);
        setAssignments([]);
        return;
      });
  }

  useEffect(() => {
    getAllAssignment();
  }, []);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = assignments.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const nPages = Math.ceil(assignments.length / recordsPerPage);
  const markDelete = () => {
    setopen(!open);
    MarkAssingmentDelete(assignmentId).then((res) => {
      if (res.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Deleted Successfully",
          showConfirmButton: true,
        }).then(() => {
          getAllAssignment();
        });
      }
    });
  };
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  const handleButtonClick = async (assignmentId, batchId) => {
    try {
      const response = getAssignments(assignmentId);
      response.then((response) => {
        const byteCharacters = atob(response.fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${batchId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.error("Error fetching or downloading PDF:", error);
    }
  };
  const SearchFilter = () => {
    if (searchtext === "") {
      setShowfilter(false);
      getAllAssignment();
      return;
    } else {
      setShowfilter(true);
      const newAssigment = assignments;
      setAllAssigments(
        newAssigment.filter((assignment) => {
          if (
            assignment.batchId.toLowerCase().includes(searchtext.toLowerCase())
          ) {
            return assignment;
          }
        })
      );
    }
  };
  useEffect(() => {
    SearchFilter();
  }, [searchtext]);

  return (
    <div>
      <ToastContainer />
      <Loader loading={loading} />
      <h2 className="component-title">Arbitrator assignments</h2>
      {open && (
        <Dialog
          open={open}
          onClose={() => {
            setopen(false);
          }}
        >
          <DialogContent>
            <DialogContentText>
              Are you sure you want to Delete this Assignment ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="custom-button"
              type="submit"
              variant="contained"
              onClick={() => {
                setopen(!open);
              }}
            >
              Cancel
            </Button>
            <Button
              className="custom-button"
              type="submit"
              variant="contained"
              onClick={() => {
                markDelete();
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <div className="component-title-container">
        <FormControl style={{ width: "600px" }}>
          <OutlinedInput
            style={{
              borderRadius: "30px",
              border: "unset",
              background: "#f8f9fb",
            }}
            size="small"
            id="header-search"
            startAdornment={
              <InputAdornment position="start">
                <SearchOutlined />
              </InputAdornment>
            }
            aria-describedby="header-search-text"
            placeholder="Search by Batch ID"
            inputProps={{
              "aria-label": "weight",
            }}
            onChange={(e) => {
              setsearchText(e.target.value);
            }}
          />
        </FormControl>
        <Link
          style={{ textDecoration: "none" }}
          to="/app/assignments/assign-arbitrator"
        >
          <Button
            endIcon={<AddIcon />}
            color="secondary"
            fullWidth
            style={{
              background:
                "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
            }}
            variant="contained"
          >
            Create
          </Button>
        </Link>
      </div>
      {loading ? (
        <LinearProgress />
      ) : (
        <div className="assigment_list">
          {!showFilter &&
            currentRecords?.map((data, index) => (
              <div variant="outlined" className="custom-card" key={index}>
                <CardContent>
                  <div className="card-header">
                    <div>
                      <h4 style={{ display: "inline" }}>
                        Batch Id : {data.batchId}{" "}
                      </h4>
                      &nbsp;{" "}
                      <Chip
                        variant="outlined"
                        size="small"
                        label={data.status}
                        color={
                          data.status === "ASSIGNED" ? "info" : "secondary"
                        }
                      />
                      <p className="sub-text" style={{ fontSize: "small" }}>
                        {`Created by ${data.userId}`}{" "}
                      </p>
                    </div>
                    <Stack direction="row" spacing={2}>
                      <Tooltip
                        title="Delete"
                        onClick={() => {
                          setopen(true);
                          setAssignmentId(data.assignmentId);
                        }}
                        sx={{ color: "rgb(0, 81, 134)" }}
                      >
                        <DeleteOutlineIcon />
                      </Tooltip>
                      <Tooltip
                        title="View"
                        onClick={() => {
                          navigate("assignment", {
                            state: { assignmentId: data.assignmentId },
                          });
                        }}
                        sx={{ color: "rgb(0, 81, 134)" }}
                      >
                        <VisibilityIcon />
                      </Tooltip>
                      <Tooltip
                        title="Download"
                        onClick={() => {
                          handleButtonClick(data.assignmentId, data.batchId);
                        }}
                        sx={{ color: "rgb(0, 81, 134)" }}
                      >
                        <FileDownloadIcon />
                      </Tooltip>
                    </Stack>
                  </div>
                  <Paper className="assignemtCards">
                    <div>
                      <span>Assignment id :</span>{" "}
                      <span className="sub-text">{data.assignmentId}</span>
                    </div>
                    <div>
                      <span>Nature of Dispute :</span>{" "}
                      <span className="sub-text">{data.natureOfDispute}</span>
                    </div>
                    <div>
                      <span>Avg Claim Value :</span>{" "}
                      <span className="sub-text">{data.maxClaimValue}</span>
                    </div>
                    <div>
                      <span> Enterprise Name :</span>{" "}
                      <span className="sub-text">{data.enterpriseName}</span>
                    </div>
                    <div>
                      <span>Complexity :</span>{" "}
                      <span className="sub-text">{data.complexity}</span>
                    </div>
                    <div>
                      <span>No. of Cases:</span>{" "}
                      <span className="sub-text">{data.noOfCases}</span>
                    </div>
                  </Paper>
                </CardContent>
              </div>
            ))}
        </div>
      )}

      {showFilter &&
        allAssigments?.map((data, index) => (
          <div variant="outlined" className="custom-card" key={index}>
            <CardContent>
              <div className="card-header">
                <div>
                  <h4 style={{ display: "inline" }}>
                    Batch Id : {data.batchId}{" "}
                  </h4>
                  &nbsp;{" "}
                  <Chip
                    variant="outlined"
                    size="small"
                    label={data.status}
                    color={data.status === "ASSIGNED" ? "info" : "secondary"}
                  />
                  <p className="sub-text" style={{ fontSize: "small" }}>
                    {`Created by ${data.userId}`}{" "}
                  </p>
                </div>
                <Stack direction="row" spacing={2}>
                  <Tooltip
                    title="Delete"
                    onClick={() => {
                      setopen(true);
                      setAssignmentId(data.assignmentId);
                    }}
                    sx={{ color: "rgb(0, 81, 134)" }}
                  >
                    <DeleteOutlineIcon />
                  </Tooltip>
                  <Tooltip
                    title="View"
                    onClick={() => {
                      navigate("assignment", {
                        state: { assignmentId: data.assignmentId },
                      });
                    }}
                    sx={{ color: "rgb(0, 81, 134)" }}
                  >
                    <VisibilityIcon />
                  </Tooltip>
                  <Tooltip
                    title="Download"
                    onClick={() => {
                      handleButtonClick(data.assignmentId, data.batchId);
                    }}
                    sx={{ color: "rgb(0, 81, 134)" }}
                  >
                    <FileDownloadIcon />
                  </Tooltip>
                </Stack>
              </div>
              <Paper className="assignemtCards">
                <div>
                  <span>Assignment id :</span>{" "}
                  <span className="sub-text">{data.assignmentId}</span>
                </div>
                <div>
                  <span>Nature of Dispute :</span>{" "}
                  <span className="sub-text">{data.natureOfDispute}</span>
                </div>
                <div>
                  <span>Avg Claim Value :</span>{" "}
                  <span className="sub-text">{data.maxClaimValue}</span>
                </div>
                <div>
                  <span> Enterprise Name :</span>{" "}
                  <span className="sub-text">{data.enterpriseName}</span>
                </div>
                <div>
                  <span>Complexity :</span>{" "}
                  <span className="sub-text">{data.complexity}</span>
                </div>
                <div>
                  <span>No. of Cases:</span>{" "}
                  <span className="sub-text">{data.noOfCases}</span>
                </div>
              </Paper>
            </CardContent>
          </div>
        ))}

      {/* {
        !showFilter && <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      } */}

      {!showFilter && (
        <div className="paginationNew">
          <Pagination
            count={Math.ceil(allAssigments.length / ITEMS_PER_PAGE)}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
          />
        </div>
      )}
    </div>
  );
}

export default Assignments;
